import PromotionsSlider from './promotions-slider';

export default PromotionsSlider;
